import Vue from 'vue'
import Router from 'vue-router'

import firebase from 'firebase'

import { store } from '../store'

import Home from '@/pages/Home'
import Sneakers from '@/pages/Sneakers'
import Brand from '@/pages/Brand'
import Sneaker from '@/pages/Sneaker'

import Profile from '@/pages/Profile'
import Collection from '@/pages/Collection'
import Stats from '@/pages/Stats'
import Wishlist from '@/pages/Wishlist'

import Login from '@/pages/Login'
import SignUp from '@/pages/SignUp'

Vue.use(Router)

const router = new Router({
    mode: 'history',
    routes: [
        { path: '/', name: 'Home', component: Home},

        { path: '/sneakers', name: 'Sneakers', component: Sneakers },
        { path: '/sneakers/:brand', name: 'Brand', component: Brand, props: true },
        { path: '/sneakers/:brand/:slug', name: 'Sneaker', component: Sneaker, props: true },

        { path: '/profile', name: 'Profile', component: Profile, meta: { requiresAuth: true } },
        { path: '/collection', name: 'Collection', component: Collection, meta: { requiresAuth: true } },
        { path: '/wishlist', name: 'Wishlist', component: Wishlist, meta: { requiresAuth: true } },
        { path: '/stats', name: 'Stats', component: Stats, meta: { requiresAuth: true } },

        { path: '/login', name: 'Login', component: Login },
        { path: '/signup', name: 'SignUp', component: SignUp },

        { path: '*', redirect: '/' }
    ]
})

router.beforeEach((to, from, next) => {
    let currentUser = store.getters.user
    let requiresAuth = to.matched.some(record => record.meta.requiresAuth);

    if (requiresAuth && !currentUser) {
        next('login')
    } else {
        next()
    } 
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js